export const formatUnsavedChangesDescription = (tabs: string[]): string => {
  if (tabs.length === 0) {
    return 'You have unsaved changes.'
  }
  const names =
    tabs.length === 1
      ? tabs[0]
      : `${tabs.slice(0, -1).join(', ')} and ${tabs[tabs.length - 1]}`
  return `You have unsaved changes in ${names}.`
}
